'use client';

import React from 'react';
import classNames from 'classnames';

import HeroBanner from '@/components/HeroBanner/HeroBanner';
import IconListing from '@/features/contentful/components/IconListing';
import MainBodyToReact from '../../components/MainBodyToReact';
import PageTitle from '../../components/PageTitle';
import NumberListing from '../../components/NumberListing';

import { TypeHeroComponentWithoutUnresolvableLinksResponse } from '../../_generated';

import { useContentfulInspectorMode } from '@contentful/live-preview/react';

export const HeroBannerWrapper: React.FC<{
    component: TypeHeroComponentWithoutUnresolvableLinksResponse;
}> = ({ component }) => {
    const { fields } = component;
    const inspectorProps = useContentfulInspectorMode({ entryId: component?.sys?.id });

    return (
        <section
            className={classNames({
                'tw-bg-bgSkyLight': fields?.backgroundColor === 'blue',
            })}
        >
            <div className="container">
                {fields.type === 'Hero Banner' && (
                    <>
                        <div
                            {...inspectorProps({
                                fieldId: 'heroImage',
                            })}
                        >
                            <HeroBanner
                                inspectorProps={inspectorProps}
                                title={fields?.heroImageTitle ?? ''}
                                subtitle={fields?.heroImageRichSubTitle}
                                image={
                                    fields?.heroImage?.fields?.file
                                        ? `https:${fields.heroImage.fields.file.url}?fm=avif`
                                        : undefined
                                }
                                imageAlt={fields?.heroImage?.fields?.title}
                            />
                        </div>
                        {fields?.blockUnderHero?.length && (
                            <div
                                {...inspectorProps({
                                    fieldId: 'blockUnderHero',
                                })}
                            >
                                {fields.blockUnderHeroComponentsType === 'Numbers' ? (
                                    <NumberListing
                                        listingItems={fields?.blockUnderHero?.map((item) => ({
                                            title: item?.fields?.content ?? '',
                                            count: item?.fields?.number ?? '',
                                            id: item?.sys?.id ?? '',
                                        }))}
                                        className="tw-pb-10"
                                    />
                                ) : (
                                    <IconListing
                                        listingItems={fields?.blockUnderHero?.map((item) => ({
                                            title: item?.fields?.content ?? '',
                                            image: item?.fields?.icon?.fields?.file
                                                ? `https:${item.fields.icon.fields.file.url}`
                                                : undefined,
                                        }))}
                                    />
                                )}
                            </div>
                        )}
                        {fields.subHeroContent && (
                            <>
                                <div
                                    className={classNames('tw-mt-10 tw-text-[#4B4F54]', {
                                        'tw-self-start tw-text-left':
                                            fields?.subContentAlignment === 'Left',
                                        'tw-self-center tw-text-center':
                                            fields?.subContentAlignment === 'Center' ||
                                            !fields?.subContentAlignment,
                                        'tw-self-end tw-text-right':
                                            fields?.subContentAlignment === 'Right',
                                    })}
                                >
                                    <MainBodyToReact
                                        body={fields.subHeroContent}
                                        classes={{
                                            p: 'tw-text-[#4b4f54] ',
                                        }}
                                        id={component?.sys?.id}
                                        fieldId="subHeroContent"
                                    />
                                </div>
                            </>
                        )}
                    </>
                )}
                {fields.type === 'Page Title' && (
                    <PageTitle
                        heroComponent={
                            {
                                sys: { id: component?.sys?.id },
                                fields: component.fields,
                            } as TypeHeroComponentWithoutUnresolvableLinksResponse
                        }
                    />
                )}
            </div>
        </section>
    );
};
